import { defineMessages } from 'react-intl-next';

export default defineMessages({
	goodResponse: {
		id: 'fabric.editor.ai.components.feedbackForm.goodResponse',
		defaultMessage: 'Good response',
		description:
			'Label on a button in an AI feedback form. The button allows the user to indicate that the AI-generated response was good. Shown alongside a thumbs-up icon as a positive feedback option.',
	},
	badResponse: {
		id: 'fabric.editor.ai.components.feedbackForm.badResponse',
		defaultMessage: 'Bad response',
		description:
			'Label on a thumbs-down button in an AI feedback form, shown after the AI generates a response in the editor. Clicking this button indicates the user is dissatisfied with the AI-generated response and submits negative feedback.',
	},
	feedbackSent: {
		id: 'fabric.editor.ai.components.feedbackForm.feedbackSent',
		defaultMessage: 'Feedback sent',
		description:
			'A message that appears to users when they click the thumbs up or thumbs down button',
	},
});
